
(() => {
  function money(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
    } catch (_) {}
    return (cents / 100).toLocaleString('tr-TR', {style:'currency',currency:'TRY'});
  }

  function initProduct(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const mainImage = root.querySelector('.product-main-image');
    const thumbs = [...root.querySelectorAll('.product-thumb')];
    const counter = root.querySelector('[data-media-counter]');
    const track = root.querySelector('[data-thumb-track]');
    const prevThumb = root.querySelector('[data-thumb-prev]');
    const nextThumb = root.querySelector('[data-thumb-next]');
    const qty = root.querySelector('[data-qty]');
    const minus = root.querySelector('[data-qty-minus]');
    const plus = root.querySelector('[data-qty-plus]');
    const add = root.querySelector('[data-add-to-cart]');
    const addLabel = root.querySelector('[data-add-label]');
    const price = root.querySelector('[data-product-price]');
    const optionSelects = [...root.querySelectorAll('[data-product-option]')];

    let productData = null;
    try {
      productData = JSON.parse(root.querySelector('[data-product-json]')?.textContent || 'null');
    } catch (_) {}

    let activeIndex = 0;

    function selectImage(index) {
      if (!thumbs.length) return;
      index = Math.max(0, Math.min(index, thumbs.length - 1));
      const thumb = thumbs[index];
      const full = thumb?.dataset.full;
      if (mainImage && full) {
        mainImage.src = full;
        mainImage.removeAttribute('srcset');
      }
      activeIndex = index;
      thumbs.forEach((t,i) => t.classList.toggle('is-active', i === index));
      if (counter) counter.textContent = `${String(index + 1).padStart(2,'0')} / ${String(thumbs.length).padStart(2,'0')}`;
      thumb?.scrollIntoView({behavior:'smooth', block:'nearest', inline:'center'});
    }

    // Thumbnail clicks open the selected media directly in the lightbox.
    // The main product image remains fixed for a faster, steadier layout.

    function scrollThumbs(direction) {
      if (!track) return;
      track.scrollBy({left: direction * Math.max(250, track.clientWidth * .72), behavior:'smooth'});
    }
    prevThumb?.addEventListener('click', (e) => { e.stopPropagation(); scrollThumbs(-1); });
    nextThumb?.addEventListener('click', (e) => { e.stopPropagation(); scrollThumbs(1); });

    function qtyValue() { return Math.max(1, Number(qty?.textContent || 1)); }
    minus?.addEventListener('click', () => { if(qty) qty.textContent = Math.max(1, qtyValue()-1); });
    plus?.addEventListener('click', () => { if(qty) qty.textContent = qtyValue()+1; });

    function syncVariant() {
      if (!productData || !optionSelects.length) return;
      const selected = optionSelects.map(s => s.value);
      const variant = productData.variants.find(v => v.options.every((value,i) => value === selected[i]));
      if (!variant) return;
      add.dataset.variantId = variant.id;
      add.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Sepete Ekle' : 'Tükendi';
      if (price) price.textContent = money(variant.price);
      if (variant.featured_image?.src && mainImage) {
        mainImage.src = variant.featured_image.src;
        mainImage.removeAttribute('srcset');
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null,'',url);
    }
    optionSelects.forEach(s => s.addEventListener('change', syncVariant));

    add?.addEventListener('click', async () => {
      const id = Number(add.dataset.variantId);
      if (!id || add.disabled) return;
      const previous = addLabel?.textContent || 'Sepete Ekle';
      add.disabled = true;
      if (addLabel) addLabel.textContent = 'Ekleniyor...';
      try {
        const res = await fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id,quantity:qtyValue()}]})
        });
        if(!res.ok) throw new Error('cart');
        if(addLabel) addLabel.textContent='Sepete Eklendi';
        document.dispatchEvent(new CustomEvent('tolun:cart-updated'));
        setTimeout(()=>{ if(addLabel) addLabel.textContent=previous; },1200);
      } catch(e) {
        if(addLabel) addLabel.textContent='Tekrar Dene';
      } finally {
        add.disabled=false;
      }
    });

    /* lightbox */
    const lightbox = document.querySelector('[data-lightbox]');
    if (!lightbox || lightbox.dataset.ready === 'true') return;
    lightbox.dataset.ready = 'true';

    const lbImage = lightbox.querySelector('[data-lightbox-image]');
    const stage = lightbox.querySelector('[data-lightbox-stage]');
    const close = lightbox.querySelector('[data-lightbox-close]');
    const prev = lightbox.querySelector('[data-lightbox-prev]');
    const next = lightbox.querySelector('[data-lightbox-next]');
    const count = lightbox.querySelector('[data-lightbox-count]');
    const sources = thumbs.length ? thumbs.map(t=>t.dataset.full).filter(Boolean) : (mainImage ? [mainImage.src] : []);
    let lbIndex = 0, zoomed=false, dragging=false, x=0, y=0, startX=0, startY=0, moved=false;

    function transform() {
      if(!lbImage) return;
      lbImage.style.transform = `translate3d(${x}px,${y}px,0) scale(${zoomed?2:1})`;
      lightbox.classList.toggle('is-zoomed',zoomed);
    }
    function resetZoom(){zoomed=false;dragging=false;x=0;y=0;transform();lightbox.classList.remove('is-dragging');}
    function show(i){
      if(!sources.length) return;
      lbIndex=(i+sources.length)%sources.length;
      lbImage.src=sources[lbIndex];
      if(count) count.textContent=`${String(lbIndex+1).padStart(2,'0')} / ${String(sources.length).padStart(2,'0')}`;
      resetZoom();
    }
    function open(i=activeIndex){
      lbIndex=i;show(lbIndex);lightbox.classList.add('is-open');lightbox.setAttribute('aria-hidden','false');document.body.classList.add('lightbox-open');
    }
    function shut(){lightbox.classList.remove('is-open');lightbox.setAttribute('aria-hidden','true');document.body.classList.remove('lightbox-open');resetZoom();}

    mainImage?.addEventListener('click',()=>open(0));
    thumbs.forEach((t,i)=>t.addEventListener('click',()=>open(i)));
    close?.addEventListener('click',shut);
    prev?.addEventListener('click',()=>show(lbIndex-1));
    next?.addEventListener('click',()=>show(lbIndex+1));

    stage?.addEventListener('click',()=>{
      if(moved){moved=false;return;}
      zoomed=!zoomed;if(!zoomed){x=0;y=0;}transform();
    });
    stage?.addEventListener('pointerdown',e=>{
      if(!zoomed)return;
      dragging=true;moved=false;startX=e.clientX-x;startY=e.clientY-y;
      lightbox.classList.add('is-dragging');stage.setPointerCapture(e.pointerId);
    });
    stage?.addEventListener('pointermove',e=>{
      if(!dragging||!zoomed)return;
      const nx=e.clientX-startX, ny=e.clientY-startY;
      if(Math.abs(nx-x)>3||Math.abs(ny-y)>3)moved=true;
      x=nx;y=ny;transform();
    });
    stage?.addEventListener('pointerup',e=>{
      dragging=false;lightbox.classList.remove('is-dragging');
      try{stage.releasePointerCapture(e.pointerId)}catch(_){}
    });
    lightbox.addEventListener('click',e=>{if(e.target===lightbox)shut();});
    document.addEventListener('keydown',e=>{
      if(!lightbox.classList.contains('is-open'))return;
      if(e.key==='Escape'){if(zoomed)resetZoom();else shut();}
      if(e.key==='ArrowLeft')show(lbIndex-1);
      if(e.key==='ArrowRight')show(lbIndex+1);
    });
  }

  function loadRecommendations() {
    const host = document.querySelector('.product-recommendations-host[data-recommendations-url]');
    if (!host || host.querySelector('.product-related') || host.dataset.loading === 'true') return;
    host.dataset.loading='true';
    fetch(host.dataset.recommendationsUrl)
      .then(r=>r.text())
      .then(html=>{
        const doc=new DOMParser().parseFromString(html,'text/html');
        const related=doc.querySelector('.product-related');
        if(related) host.innerHTML=related.outerHTML;
      })
      .catch(()=>{});
  }

  function boot(){
    document.querySelectorAll('[data-tolun-product]').forEach(initProduct);
    loadRecommendations();
  }
  document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();
